/* nav-isolated.js – Shopify-safe navbar behaviors + over-hero overlay control */
(function () {
  'use strict';

  function isHomeByPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var path = window.location.pathname || '/';
    return path === '/' || path === root;
  }

  function isLandingPageAuto() {
    // Shopify commonly adds template-index to <body> on the homepage
    if (document.body && document.body.classList && document.body.classList.contains('template-index')) return true;
    return isHomeByPath();
  }

  function initNav(cfg) {
    const c = Object.assign(
      {
        mainBar: ".nav-bar.main",
        collapsibleBar: ".nav-bar.collapsible",
        hero: ".hero-slider-container",

        // Crossfade + hide/show
        fadeDistance: 400,
        hideDistance: 12,
        hideTranslateY: -100, // percentage

        // Anchor offset
        fixedHeaderForOffset: "header, .header, .w-nav, .nav-bar.main, .nav-bar.collapsible",

        // Overlay behavior over hero
        overlaySelector: ".nav-bg-overlay",
        heroOverlapPadding: 0, // allow tweaking overlap threshold
      },
      cfg || {}
    );

    const main = document.querySelector(c.mainBar);
    const coll = document.querySelector(c.collapsibleBar);
    const hero = document.querySelector(c.hero);

    // Prefer explicit flag if you set it in Liquid, otherwise auto-detect
    const isLandingPage =
      (typeof window.SG_IS_LANDING_PAGE !== "undefined")
        ? (window.SG_IS_LANDING_PAGE === true)
        : isLandingPageAuto();

    // Collect overlays inside both nav bars (hero + collapsible)
    const overlays = Array.from(document.querySelectorAll(c.overlaySelector));
    overlays.forEach((el) => {
      if (!el.dataset.defaultOpacity) {
        const cs = window.getComputedStyle(el);
        el.dataset.defaultOpacity = (cs && cs.opacity != null) ? String(cs.opacity) : "1";
      }
    });

    console.log("Nav Init:", {
      main: !!main,
      collapsible: !!coll,
      hero: !!hero,
      isLandingPage,
      overlays: overlays.length
    });

    let lastY = window.scrollY;
    let ticking = false;

    // Initial visual state
    if (isLandingPage) {
      if (main) {
        main.style.opacity = "1";
        main.style.pointerEvents = "auto";
        main.removeAttribute("aria-hidden");
      }
      if (coll) {
        coll.style.opacity = "0";
        coll.style.pointerEvents = "none";
        coll.style.transform = "translateY(0%)";
        coll.removeAttribute("aria-hidden");
      }
    } else {
      if (main) {
        main.style.opacity = "0";
        main.style.pointerEvents = "none";
        main.setAttribute("aria-hidden", "true");
      }
      if (coll) {
        coll.style.opacity = "1";
        coll.style.pointerEvents = "auto";
        coll.style.transform = "translateY(0%)";
        coll.removeAttribute("aria-hidden");
      }
    }

    function measureHeaderOffset() {
      let offset = 0;
      document.querySelectorAll(c.fixedHeaderForOffset).forEach((el) => {
        const style = window.getComputedStyle(el);
        const isFixed = style.position === "fixed" || style.position === "sticky";
        const isVisible = style.display !== "none" && style.visibility !== "hidden" && el.offsetHeight > 0;
        if (isFixed && isVisible) offset += el.offsetHeight;
      });
      return offset;
    }

    function setOverHeroOverlayOpacity(overHero) {
      // Only apply this behavior when the hero exists (homepage with hero section)
      if (!hero || !overlays.length) return;

      overlays.forEach((el) => {
        if (overHero) {
          el.style.opacity = "0";
        } else {
          // Restore whatever the theme CSS wanted
          el.style.opacity = el.dataset.defaultOpacity || "";
        }
      });
    }

    function computeOverHero() {
      if (!hero) return false;

      // Use whichever bar is currently in play; fallback to header height if needed
      const navEl = (coll && window.getComputedStyle(coll).opacity !== "0") ? coll : (main || coll);
      const navH = navEl ? navEl.offsetHeight : 0;

      const r = hero.getBoundingClientRect();
      const threshold = navH + (c.heroOverlapPadding || 0);

      // “Navbar overlaps hero” when the hero still covers the navbar’s vertical zone
      return (r.top <= threshold) && (r.bottom > threshold);
    }

    function onScroll() {
      const y = window.scrollY;
      const delta = y - lastY;

      const t = Math.min(Math.max(y / c.fadeDistance, 0), 1);

      if (isLandingPage) {
        if (main) {
          const mainOpacity = 1 - t;
          main.style.opacity = String(mainOpacity);
          main.style.pointerEvents = mainOpacity > 0.05 ? "auto" : "none";
          if (mainOpacity <= 0.001) main.setAttribute("aria-hidden", "true");
          else main.removeAttribute("aria-hidden");
        }

        if (coll) {
          coll.style.opacity = String(t);
          const interactive = t > 0.2;
          coll.style.pointerEvents = interactive ? "auto" : "none";

          if (interactive && !coll._dropdownReadyEmitted) {
            coll._dropdownReadyEmitted = true;
            document.dispatchEvent(new CustomEvent("navbar:collapsible-ready"));
          }
        }
      } else {
        if (main) {
          main.style.opacity = "0";
          main.style.pointerEvents = "none";
          main.setAttribute("aria-hidden", "true");
        }
        if (coll) {
          coll.style.opacity = "1";
          coll.style.pointerEvents = "auto";
        }
      }

      if (coll && Math.abs(delta) >= c.hideDistance) {
        const hoverOpen = document.querySelector(".dropdown-shop-all.visible");
        const blockHide =
          document.body.classList.contains("menu-open") ||
          document.body.classList.contains("dropdown-open") ||
          !!hoverOpen;

        if (blockHide) {
          coll.style.transform = "translateY(0%)";
        } else if (delta > 0) {
          coll.style.transform = `translateY(${c.hideTranslateY}%)`;
        } else {
          coll.style.transform = "translateY(0%)";
        }
      }

      // Your existing “near end of hero” class toggle
      if (isLandingPage && coll && hero) {
        const heroRect = hero.getBoundingClientRect();
        const nearEnd = heroRect.bottom <= window.innerHeight * 0.98;
        coll.classList.toggle("is-sooty", nearEnd);
      }

      // Overlay opacity rule: transparent only while overlapping hero
      setOverHeroOverlayOpacity(isLandingPage && computeOverHero());

      lastY = y;
      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }

    window.addEventListener("scroll", requestTick, { passive: true });
    window.addEventListener("resize", requestTick);
    requestTick();

    function isLocalAnchor(href) {
      if (!href || href.charAt(0) !== "#") return false;
      return document.getElementById(href.slice(1)) != null;
    }

    function smoothScrollTo(target) {
      const rect = target.getBoundingClientRect();
      const headerOffset = measureHeaderOffset();
      const absoluteY = window.pageYOffset + rect.top - headerOffset;
      window.scrollTo({ top: absoluteY, behavior: "smooth" });
    }

    document.addEventListener("click", (e) => {
      const a = e.target.closest("a[href^='#']");
      if (!a) return;

      const href = a.getAttribute("href");
      if (!isLocalAnchor(href)) return;

      const target = document.getElementById(href.slice(1));
      if (!target) return;

      e.preventDefault();
      smoothScrollTo(target);
    });

    console.log("Navbar behavior initialized");
  }

  // Expose
  window.NavIsolated = { initNav };

  // Auto-init once (Shopify-safe)
  function autoInitOnce() {
    if (window.__SG_NAV_INIT_DONE) return;
    window.__SG_NAV_INIT_DONE = true;

    // If you want to force landing detection from Liquid, set this in header:
    // <script>window.SG_IS_LANDING_PAGE = {{ request.page_type == 'index' | json }};</script>
    initNav();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoInitOnce);
  } else {
    autoInitOnce();
  }

  // Theme editor: re-run the scroll computation after section reloads (without double-binding listeners)
  document.addEventListener("shopify:section:load", function () {
    // Do not call initNav again; just trigger a scroll tick
    window.dispatchEvent(new Event("resize"));
  });
})();
